import { changeOpacity } from "@client/lib/color";

const JS_TO_CSS_NUMBER_PIXELS_EXCEPTION = {
  fontWeight: null
};
const normalizeCSSValue = (key: string, value: any) =>
  typeof value === "number" && !(key in JS_TO_CSS_NUMBER_PIXELS_EXCEPTION) ? `${value}px` : value;
export const JSToCSS = (JS: object) =>
  Object.keys(JS)
    .filter((key) => JS[key] !== undefined)
    .map(
      (key) => "\t" + key.replace(/([A-Z])/g, (g) => `-${g[0].toLowerCase()}`) + `: ${normalizeCSSValue(key, JS[key])};`
    )
    .join("\n");

const processKnownFunctions = (tpl: string): string => {
  const changeOpacityRegex = /changeOpacity\((.+),\s*([^)]+)\)/g;
  return tpl.replace(changeOpacityRegex, (m, c, o) => changeOpacity(c, o));
};

export const compileCtpl = (tpl: string, data: object): string =>
  processKnownFunctions(
    Object.keys(data).reduce((res, key) => {
      const value = data[key];
      return res.replace(new RegExp(`%${key}%`, "g"), typeof value === "object" ? JSToCSS(value) : value ?? "");
    }, tpl)
  );
